import { render, staticRenderFns } from "./AgendaFilter.vue?vue&type=template&id=c3763058"
import script from "./AgendaFilter.vue?vue&type=script&lang=js"
export * from "./AgendaFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports